module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "walletStatementWrapper"
    }
  }, [(_vm.shown.digitalWallets) ? _c('multi-select-modal', {
    attrs: {
      "id": "digitalWalletsModal",
      "data": _vm.data.digitalWallets
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('saldoCarteiraDigital.titulos.saldoCarteiraDigital'),
      "subTitle": _vm.$t('saldoCarteiraDigital.titulos.visualize')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('saldoCarteiraDigital.titulos.filtroTitulo')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "showLoadingFullPage": false,
      "hasExportFile": false
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 31,
      "finalDateDisableFrom": _vm.finalDateDisable
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _c('div', {
    staticClass: "row row-filter-small"
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('saldoCarteiraDigital.labels.carteirasDigitais'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.digitalWallets.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.digitalWallets,
      "props": _vm.inputTagsProps.digitalWallets
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.digitalWallets, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filter-input-tag",
    attrs: {
      "title": _vm.$t('saldoCarteiraDigital.labels.selecionarCarteirasDigitais'),
      "id": "btnSelecionarCarteirasDigitais",
      "faIcon": "fa fa-search",
      "clickFunction": _vm.openSelectDigitalWalletsModal
    }
  })], 1)])])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "SaldoCarteiraDigital",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "SaldoCarteiraDigital",
      "treeGridLayoutPath": "digitalWalletBalance",
      "showMassTaskAction": false,
      "showAlert": true,
      "alertMessage": _vm.$t('saldoCarteiraDigital.labels.alertaGrid'),
      "cfgObj": _vm.treeGridCfg
    }
  })], 1)], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bb3e89cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb3e89cc"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/reports/digitalWalletBalance/digitalWalletBalance.pug
// module id = 1455
// module chunks = 0